export const shortcutMap = {
  'Table shortcuts': {
    'Add new table': 'meta + alt + t',
    'Add column left': 'meta + shift + left arrow',
    'Add column right': 'meta + shift + right arrow',
    'Add row above': 'meta + shift + up arrow',
    'Add row below': 'meta + shift + down arrow',
    'Delete column': 'ctrl + alt + backspace',
    'Delete row': 'meta + alt + backspace',
    'Delete table': 'shift + alt + backspace',
  },
  'Text styling shortcuts': {
    'Bolden text': 'meta + b',
    'Italicize text': 'meta + i',
    'Underline text': 'meta + u',
    'Strikethrough text': 'meta + shift + s',
  },
  'Other shortcuts': {
    'Focus editor': 'meta + e',
    'Focus controlbar': 'meta + f9',
  },
}
